import React, { useState, useEffect } from 'react';
import InsurancePatientInfoService from "../patientInfo/InsurancePatientInfoService";
import apiBaseUrl from "../../utils/config";
import "./searchPopupDesign.css"; // optional

const RegisterInsurancePatient = () => {
    const [patientId, setPatientId] = useState("");
    const [patientName, setPatientName] = useState("");
    const [insId, setInsId] = useState("");
    const [insuranceName, setInsuranceName] = useState("");
    const [subscriber, setSubscriber] = useState("");
    const [active, setActive] = useState("");
    const [coPay, setCoPay] = useState("");
    const [notes, setNotes] = useState("");

    const insurancePatientService = new InsurancePatientInfoService();

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.target === "patientId") {
                setPatientId(event.data.value);
                setPatientName(event.data.displayName);
            }
            if (event.data.target === "insId") {
                setInsId(event.data.value);
                setInsuranceName(event.data.displayName);
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

   const openSearchPopup = (target) => {
    let urlParam = "";
    let typeParam = "";

    if (target === "patient") {
        urlParam = `${apiBaseUrl}/patientinfo/search/all`;
        typeParam = "Patient";
    } else if (target === "insurance") {
        urlParam = `${apiBaseUrl}/insurance/search/all`;
        typeParam = "Insurance";
    }

    const searchUrl = `/search-popup?type=${typeParam}&target=${target === "patient" ? "patientId" : "insId"}&url=${encodeURIComponent(urlParam)}`;
    window.open(searchUrl, "popup", "width=600,height=400");
};


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!patientId || !insId) {
            alert("Please select a patient and insurance.");
            return;
        }

        const data = {
            patientId,
            insId,
            subscriber: subscriber.trim(),
            active: active.trim(),
            coPay: parseFloat(coPay.trim()),
            notes: notes.trim(),
        };

        try {
            const response = await insurancePatientService.addInsurancePatient(data);
            alert("Registration Successful: " + JSON.stringify(response));
        } catch (err) {
            alert("Registration Failed: " + err.message);
        }
    };

 return (
  <div className="form-wrapper">
    <form id="insurancePatientRegistrationForm" onSubmit={handleSubmit}>
      <button type="button" onClick={() => openSearchPopup("patient")}>
        Search Patient
      </button>
      <input type="text" value={patientName} readOnly placeholder="Selected Patient" />
      <input type="hidden" value={patientId} />

      <button type="button" onClick={() => openSearchPopup("insurance")}>
        Search Insurance
      </button>
      <input type="text" value={insuranceName} readOnly placeholder="Selected Insurance" />
      <input type="hidden" value={insId} />

      <input
        type="text"
        placeholder="Enter Subscriber ID"
        title="Subscriber identification number."
        value={subscriber}
        onChange={(e) => setSubscriber(e.target.value)}
      />
      <input
        type="text"
        placeholder="Enter Active Status"
        title="Yes/No"
        value={active}
        onChange={(e) => setActive(e.target.value)}
      />
      <input
        type="number"
        placeholder="Enter Co-Pay"
        title="Amount patient needs to pay."
        value={coPay}
        onChange={(e) => setCoPay(e.target.value)}
      />
      <textarea
        placeholder="Enter Notes"
        title="Additional details."
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />
      <button type="submit">Register Insurance Patient</button>
    </form>
  </div>
);

};

export default RegisterInsurancePatient;
